import {AfterViewInit, Component, Inject, Optional, ViewChild} from '@angular/core';
import {AdReportParams, AdRequestOptions, AdRequestParams} from '../../../../../shared/interfaces/ad-reports';
import {ReportsTableService} from '../../../../../shared/services/reports-table.service';
import {ReportsRequestsService} from '../../../../../shared/services/reports-requests.service';
import {AdReportsTableComponent} from "../../../../../shared/components/ad-reports-table/ad-reports-table.component";
import {AgGridEvent} from "@ag-grid-community/core";
import {ReportStore} from '../../../../../shared/store/report/report.store';
import {ReportTableStore} from '../../../../../shared/store/report/report-table.store';
import {DashboardWidget} from '../../../../../shared/store/report/report-dashboard';
import {ReportDashboardWidgetStore} from '../../../../../shared/store/report/report-dashboard-widget.store';
import {ReportDashboardStore} from '../../../../../shared/store/report/report-dashboard.store';
import {first} from 'rxjs/operators';
import {ReportParamsStore} from '../../../../../shared/store/report/report-params.store';
import {Serializer} from "../../../../../shared/interfaces/serializer";
import {SavedReport} from "../../../../../shared/interfaces/saved-reports";

@Component({
  selector: 'app-widget-ad-reports-table',
  templateUrl: './widget-table.component.html',
  styleUrls: ['./widget-table.component.scss'],
  providers: [
    ReportStore,
    ReportParamsStore,
    ReportTableStore,
    ReportsTableService,
    ReportsRequestsService
  ]
})
export class WidgetTableComponent implements AfterViewInit {
  @ViewChild(AdReportsTableComponent) private _table: AdReportsTableComponent;

  constructor(
    @Optional() @Inject('widget') private readonly _widget: DashboardWidget,
    @Optional() @Inject('widgetRequestParams') public readonly _widgetRequestParams: Partial<AdRequestParams>,
    @Optional() @Inject('widgetReportParams') private readonly _widgetReportParams: Partial<AdReportParams>,
    @Optional() @Inject('widgetRequestOptions') public readonly _widgetRequestOptions: Partial<AdRequestOptions>,
    @Optional() @Inject('uuid') private readonly _uuid: string,
    @Optional() @Inject('token') private readonly _token: string,
    @Optional() @Inject('readonly') public readonly readonly: boolean,
    @Optional() @Inject('report') public readonly _report: Serializer<SavedReport>,
    private readonly _reportDashboardStore: ReportDashboardStore,
    private readonly _reportDashboardWidgetStore: ReportDashboardWidgetStore,
    private readonly _reportStore: ReportStore,
    private readonly _reportTableStore: ReportTableStore,
    private readonly _reportsTableService: ReportsTableService
  ) {}

  ngAfterViewInit(): void {
    this._reportsTableService.suppressCellDimensionFilter = true;
    this._reportStore.initParams(
      this._widgetRequestParams,
      this._widgetReportParams,
      this._widgetRequestOptions,
      this._widget.config.limit,
      this._uuid,
      this._token,
      this._report
    );

    this._reportDashboardWidgetStore.setResizeFunction((): void => {
      this._table.agGridC.sizeColumnsToFit();
    });
  }

  public onTableChanges(agGrid: AgGridEvent): void {
    this._reportStore.requestParams$
      .pipe(first())
      .subscribe((params: Partial<AdRequestParams>): void => {
        this._widget.config.column_state = agGrid.columnApi.getColumnState();

        this._widget.config.dimension_orders = params.dimension_orders || [];
        this._widget.config.metric_orders = params.metric_orders || [];
        this._widget.config.dimension_filters = params.dimension_filters || [];
        this._widget.config.metric_filters = params.metric_filters || [];
        this._widget.config.limit = agGrid.api.paginationGetPageSize();
        this._reportDashboardStore.update();
      });
  }

  public onDragStop(params: Partial<AdRequestParams>): void {
    this._widget.config.metrics = params.metrics;
    this._widget.config.dimensions = params.dimensions;
    this._reportDashboardStore.update();
  }

}
